import printLocationBarcodesComponent from './print_location_barcodes.component';

let printLocationBarcodesModule = angular.module('printLocationBarcodes', [
])
	.config(($stateProvider, $urlRouterProvider) => {
		"ngInject";

		$stateProvider
			.state('printLocationBarcodes', {
				url: '/print-location-barcodes',
				component: 'printLocationBarcodes',
				data: {
					requireLogin: true,
					requireACL: 'setting-location.view'
				},
			});
	})

	.component('printLocationBarcodes', printLocationBarcodesComponent)

	.name;

export default printLocationBarcodesModule;


// WEBPACK FOOTER //
// ./client/app/components/location/print/index.js